import { withStyles } from '@material-ui/core/styles'

import { Generic, Organisation, Product, Profile, Team } from './images'

// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  placeholder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '70%',
    },
  },
})

const Placeholder = ({ classes, color, variant }) => (
  <div className={classes.placeholder}>
    {(() => {
      switch (variant) {
        case 'profile':
          return <Profile fill={color} />
        case 'organisation':
          return <Organisation fill={color} />
        case 'team':
          return <Team fill={color} />
        case 'product':
        case 'productImage':
          return <Product fill={color} />
        default:
          return <Generic fill={color} />
      }
    })()}
  </div>
)

Placeholder.defaultProps = {
  color: '#8196B6',
  variant: 'generic',
}

const PlaceholderComponent = withStyles(styles)(Placeholder)
PlaceholderComponent.displayName = 'Placeholder'
export default PlaceholderComponent
